import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class Theme extends Component {
    static propTypes = {
        namespace: PropTypes.string.isRequired,
        colorPalette: PropTypes.object.isRequired
    };

    static defaultProps = {
        colorPalette: {}
    };

    render() {
        const { namespace, colorPalette } = this.props;

        const $darkestBlue = '#02072c';
        const $white = '#ffffff';
        const $lightGray = '#eef0f5';
        const $darkRat = '#222222';

        return (
            <style id={`theme-${namespace}`}>
                {`
                #${namespace} .video-cta,
                #${namespace} .show-cta {
                    border-color: ${colorPalette.main};
                    color: ${colorPalette.main};
                }

                #${namespace} .video-cta .video-cta-text,
                #${namespace} .show-cta .show-cta-text {
                    color: ${colorPalette.main};
                }

                #${namespace} .show-cta.pill-button-component,
                #${namespace} .show-cta.pill-button-component .show-cta-text {
                    color: ${$white};
                }

                #${namespace} .video-cta:hover,
                #${namespace} .show-cta:hover,
                #${namespace} .show-cta:focus,
                #${namespace} .video-cta:focus {
                    background-color: ${colorPalette.accent1};
                    border-color: ${colorPalette.accent1};
                    color: ${colorPalette.accent4};
                }

                #${namespace} .video-cta:hover .video-cta-text,
                #${namespace} .show-cta:hover .show-cta-text,
                #${namespace} .show-cta:focus .show-cta-text,
                #${namespace} .video-cta:focus .video-cta-text {
                    color: ${colorPalette.accent4};
                }

                #${namespace} .season-filter .react-select__single-value,
                #${namespace} .season-filter .react-select__control,
                #${namespace} .season-filter .react-select__dropdown-indicator svg {
                    border-color: ${colorPalette.main};
                    color: ${colorPalette.main};
                }

                #${namespace} .season-filter .react-select__option--is-focused,
                #${namespace} .season-filter .react-select__option--is-selected,
                #${namespace} .season-filter .react-select__control:hover {
                    background-color: ${colorPalette.accent1};
                    color: ${colorPalette.accent4};
                    border-color: ${colorPalette.accent1};
                }

                #${namespace} .season-filter .react-select__menu .react-select__option.react-select__option--is-focused,
                #${namespace} .season-filter .react-select__menu .react-select__option.react-select__option--is-selected,
                #${namespace} .season-filter .react-select__control:hover .react-select__dropdown-indicator svg,
                #${namespace} .season-filter .react-select__control:hover .react-select__single-value {
                    color: ${colorPalette.accent4};
                }

                #${namespace} .season-filter.pill-button-component .react-select__option--is-focused,
                #${namespace} .season-filter.pill-button-component .react-select__option--is-selected,
                #${namespace} .season-filter.pill-button-component .react-select__control:hover {
                    background-color: ${$white};
                    color: ${$darkestBlue};
                    border-color: ${$darkestBlue};
                }

                #${namespace} .season-filter.pill-button-component .react-select__option.react-select__option--is-focused,
                #${namespace} .season-filter.pill-button-component .react-select__option.react-select__option--is-focused:hover {
                    background-color: ${$lightGray};
                    color: ${$darkRat};
                    border-color: ${$lightGray};
                }

                #${namespace} .season-filter.pill-button-component .react-select__control:hover .react-select__single-value,
                #${namespace} .season-filter.pill-button-component .react-select__control:hover .react-select__dropdown-indicator svg {
                    color: ${$darkestBlue};
                    border-color: ${$darkestBlue};
                }

                #${namespace} .season-filter.pill-button-component .react-select__option.react-select__option--is-selected,
                #${namespace} .season-filter.pill-button-component .react-select__option.react-select__option--is-selected:hover {
                        background-color: ${$darkestBlue};
                        color: ${$white};
                        border-color: ${$darkestBlue};
                }

                #${namespace} .load-more {
                    color: ${colorPalette.main};
                }

                #${namespace} .load-more:hover,
                #${namespace} .load-more:focus {
                    background-color: ${colorPalette.accent1};
                    border-color: ${colorPalette.accent1};
                    color: ${colorPalette.accent4};
                }
            `}
            </style>
        );
    }
}
